






























































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import Character, { CharacterShortData, CharacterExportData } from '@/classes/character/character';
import players from '@/constants/players';
import ValueAttribute, { ValueExport } from '@/classes/attributes/valueAttribute';
import { User } from '../../interfaces/User';
import { CharacterClasses } from '@/classes/character/classes';
import { Prop } from 'vue-property-decorator';
import ClassCardSelectionDialog from './classCardSelectionDialog.vue';
import EditCharacterDialog from './editCharacterDialog.vue';
import CharacterDetail from './characterDetail.vue';
import ClassCard from './classCard.vue';
import { ClassCardData, UpdateCharacterClassCardsPayload } from '@/interfaces/character/classCard';
import { UrangstReason, allUrangste } from '@/classes/character/allValues';

@Component({
  components: {
    ClassCardSelectionDialog,
    EditCharacterDialog,
    CharacterDetail,
    ClassCard,
  },
})
export default class SingleCharacterShort extends Vue {
  @Prop()
  private characterShort!: CharacterShortData;

  @Prop({ default: false })
  private extendedView!: boolean;

  @Prop({ default: false })
  private showCurrentValues!: boolean;

  @Prop({ default: false })
  private showClasscards!: boolean;

  private loading = true;
  private isClassCardDialogSaving = false;
  private detailDialog = false;
  private classCardDialog = false;
  private editCharacterDialog = false;
  private addClassIndex: number | null = null;
  private classCardToAdd: string = '';
  private loadingValues: object = {};

  get userId() {
    return this.$store.getters.userId;
  }

  get allClassCardsBySelectedClass() {
    const cards: ClassCardData[] = this.$store.getters.classCardsByClass(this.characterShort.class);
    return cards.sort((cardA, cardB) => (cardA.title < cardB.title ? -1 : 1));
  }

  get availableClassCards(): ClassCardData[] {
    if (this.character === null || typeof this.character.classcards === 'undefined') {
      return [];
    }
    return this.character.classcards.filter((card) => {
      if (this.character === null || typeof this.character.activeClasscards === 'undefined') {
        return true;
      }
      return !this.character.activeClasscards.map((data) => (data === null ? '' : data.id)).includes(card.id);
    });
  }

  get availableClassCardsItems() {
    return this.availableClassCards.map((card) => {
      return { text: card.title, value: card.id };
    });
  }

  get character(): Character | null {
    if (this.loading) {
      return null;
    } else {
      return new Character(this.$store.getters.getCharacter(this.characterShort.characterId));
    }
  }

  get doubts() {
    return [
      UrangstReason.urangst,
      UrangstReason.panik,
      UrangstReason.wut,
      UrangstReason.irrsinn,
      UrangstReason.vergessen,
    ];
  }

  get characterText() {
    if (this.character === null) {
      return '';
    } else {
      return this.character.getCharacterText().replace(/\n/g, '<br>');
    }
  }

  public mounted() {
    this.$store.dispatch('loadCharacter', this.characterShort.characterId).then(() => {
      this.loading = false;
    });
  }

  /**
   * Returns the name of the user for that userId
   */
  private getUserNameOfCharacter(userId: string) {
    const allGroupUsers: User[] = this.$store.getters.members;
    const foundUser = allGroupUsers.find((user) => user.uid === userId);
    if (!foundUser) {
      return userId;
    } else {
      return foundUser.name;
    }
  }

  private getDoubtByReason(reason: UrangstReason) {
    if (this.character === null) {
      return '';
    }

    const doubtId = this.character.getDoubtByReason(reason);
    if (doubtId === null || !allUrangste[doubtId]) {
      return 'Keine';
    } else {
      return allUrangste[doubtId];
    }
  }

  /**
   * True if this character has an avatar, false otherwise
   */
  private hasAvatar(character: CharacterShortData) {
    const firstName = character.name.split(' ')[0].toLowerCase();
    return players.findIndex((player) => player.short.toLowerCase() === firstName) > -1;
  }

  /**
   * Gets the CSS Class for this characters avatar
   */
  private getAvatarCSSClass(character: CharacterShortData) {
    return character.name.split(' ')[0].toLowerCase();
  }

  /**
   * Returns the name of the characters class based on the id/value
   */
  private getClassName(classValue: string) {
    const foundClass = CharacterClasses.allClasses.find((combo) => combo.value === classValue);
    if (typeof foundClass === 'undefined') {
      return classValue;
    }
    return foundClass.text;
  }

  private isCurrentValueLoading(abbreviation: string) {
    if (typeof this.loadingValues[abbreviation] === 'undefined') {
      return false;
    }
    return this.loadingValues[abbreviation];
  }

  private getFinalValueOfAttribute(abbreviation: string) {
    if (this.character === null) {
      return null;
    }
    try {
      const value = (this.character.getFinalValueByAbbreviation(abbreviation) as ValueAttribute).value;
      return '/ ' + value;
    } catch (error) {
      return null;
    }
  }

  /**
   * EVENT HANDLERS
   */

  private onCurrentValueChange(value: ValueExport, newValue) {
    if (this.character === null) {
      throw new Error('Character is null, cannot change current value');
    }
    this.character.setCurrentResource(value.abbreviation, newValue);
    const exportData = this.character.export();
    const payload = {
      characterId: this.characterShort.characterId,
      currentValues: exportData.currentValues,
    };
    Vue.set(this.loadingValues, value.abbreviation, true);
    this.$store.dispatch('changeCharacterCurrentValues', payload).finally(() => {
      Vue.set(this.loadingValues, value.abbreviation, false);
    });
  }

  private onClassCardDialogSave(selectedClassCards: ClassCardData[]) {
    const payload: UpdateCharacterClassCardsPayload = {
      characterId: this.characterShort.characterId,
      classCards: selectedClassCards,
    };
    this.isClassCardDialogSaving = true;
    this.$store.dispatch('updateCharacterClassCards', payload).then(() => {
      this.isClassCardDialogSaving = false;
      this.classCardDialog = false;
    });
  }

  private onClassCardClick(index: number) {
    if (index !== this.addClassIndex) {
      this.addClassIndex = index;
    } else if (this.classCardToAdd !== '') {
      // Fetch the classcard based on its id
      const card = this.availableClassCards.find((cardToSearch) => cardToSearch.id === this.classCardToAdd);
      if (typeof card === 'undefined') {
        throw new Error('Card ' + this.classCardToAdd + ' is not available');
      }
      const payload = {
        characterId: this.characterShort.characterId,
        index,
        classCard: card,
      };
      this.$store.dispatch('setActiveClassCard', payload);
    }
  }

  private onRemoveClassCardClick(index: number) {
    const payload = {
      characterId: this.characterShort.characterId,
      index,
      classCard: null,
    };
    this.$store.dispatch('setActiveClassCard', payload);
  }
}
